<template>
  <div class="img-header"
  :class="{ 'login-banner': type === 'login' || type === 'login-team', 'showcase': type === 'showcase' }">
    <img src="../assets/login-banner.jpg" v-if="type === 'login'">
    <img src="../assets/login-team-banner.png" v-if="type === 'login-team'">
    <img src="../assets/index-banner.jpg" v-if="type === 'index'">
    <img src="../assets/company_introduce.png" v-if="type === 'company-index'">
    <img src="../assets/introduction-team.png" v-if="type === 'team-index'">
    <img src="../assets/introduction-nocar.jpg" v-if="type === 'introduction' && !hasCar">
    <img src="../assets/introduction-hascar.jpg" v-if="type === 'introduction' && hasCar">
    <img src="../assets/showcase-rent-banner.jpg" v-if="type === 'showcase' && rent">
    <img src="../assets/showcase-sale-banner.jpg" v-if="type === 'showcase' && !rent">
    <div class="img-header-content" v-if="type === 'company-index'">
      <h1>有车无车都能开专车</h1>
      <p>{{companyName}}与优驾开放平台合作招募</p>
    </div>
  </div>
</template>

<style lang="stylus" scoped>
.img-header {
  position: relative;
  width: 750px;
  height: 300px;

  &.login-banner {
    height: 480px;
  }

  &.showcase {
    height: 200px;
  }

  img {
    width: 100%;
    height: 100%;
  }

  .img-header-content {
    position: absolute;
    bottom: 12px;
    left: 60px;
    right: 60px;
    padding: 20px 40px;
    display: flex;
    flex-flow: column nowrap;
    align-items: center;
    background-color: rgba(0, 0, 0, 0.6);

    h1 {
      font-weight: bolder;
      font-size: 38px;
      color: #40efe3;
      line-height: 2;
    }

    p {
      color: #fff;
      font-size: 26px;
      text-align: center;
      line-height: 1.5;
    }
  }
}
</style>

<script>
export default {
  props: {
    type: {
      type: String,
      default: 'index'
    },
    hasCar: {
      type: Boolean,
      default: true
    },
    rent: {
      type: Boolean,
      default: true
    },
    companyName: {
      type: String,
      default: ''
    }
  }
}
</script>
